import React from 'react';
import styled from 'styled-components';

import Box from 'components/Box';
import Icon from 'components/Icon';
import { Tag } from 'components/ListingStatusLabel';

import { colors } from '../theme';

const StyledTag = styled(Tag)`
  padding-top: 3px;
`;

export function ActivelyHiringBadge() {
  return (
    <StyledTag color={colors.waterBlue} bg={colors.lightGrey}>
      <Box display="flex">
        <Box pr="6px" display="inline">
          <Icon
            stroke={colors.waterBlue}
            name="upwardtrend"
            width={12}
            height={12}
            display="inline"
          />
        </Box>
        <span>{getText('Actively Hiring')}</span>
      </Box>
    </StyledTag>
  );
}
